<style lang="scss" scoped>
@import "@/styles/variables.scss";
.avatar-upload {
    position: relative;
    cursor: pointer;
    .profile-image {
        height: 80px;
        width: 80px;
        border-radius: 50%;
        cursor: pointer;
        object-fit: cover;
        &:hover {
            border: 1px solid $secondary;
        }
    }
    input[type="file"] {
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}
.tel-select {
    border-radius: $border-radius 0 0 $border-radius;
    border-color: $input-group-addon-border-color;
    background: $input-group-addon-bg;
    color: $secondary;
    &:focus {
        outline: none;
    }
    option{
        background: #fff;
    }
}
</style>

<template>
    <box :padding="45" :loading="loading">
        <template slot="content">
            <form @submit.prevent="" @keydown.enter.prevent="">
                <div class="form-row">
                    <div class="form-group col-md-6 mb-45">
                        <label class="avatar-upload" for="uploadPhotos">
                            <template v-if="!new_image">
                                <img v-if="user.profile_picture" class="profile-image" :src="getImage(user.profile_picture.image.original.url)">
                                <div v-else class="profile-image d-flex">
                                    <i-profile class="i-20 m-auto"></i-profile>
                                </div>
                            </template>
                            <img v-else class="profile-image" :src="new_image">
                            <input type="file" name="profilepicture" accept="image/*" @change="onFileChange">
                            <span class="text-secondary my-auto ml-15">{{ $t('profile.changephoto') }}</span>
                        </label>
                    </div>
                    <div class="col-md-6 d-flex">
                        <rating class="ml-auto" :total="user.driver_rating_total" :count="user.driver_rating_count" :showCount="true"></rating>
                    </div>
                </div>

                <!-- Firstname, Lastname -->
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="firstName">{{ $t('register.firstname') }} <span class="ml-auto text-danger">{{ errors.first('firstname') }}</span></label>
                        <input v-model="profile.first_name" v-validate="'required'" type="text" name="firstname" class="form-control" id="firstName" :placeholder="$t('register.firstname')">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="lastName">{{ $t('register.lastname') }} <span class="ml-auto text-danger">{{ errors.first('lastname') }}</span></label>
                        <input v-model="profile.last_name" v-validate="'required'" type="text" name="lastname" class="form-control" id="lastName" :placeholder="$t('register.lastname')">
                    </div>
                </div>

                <!-- Birthdate -->
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="birthdate">{{ $t('register.birthday') }} <span class="ml-auto text-danger">{{ errors.first('birthdate') }}</span></label>
                        <datepicker v-model="profile.birthday" format="yyyy-MM-dd" v-validate="'required'" type="date" name="birthdate" input-class="form-control bg-white" id="birthdate" :placeholder="$t('register.birthday')"></datepicker>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="language">{{ $t('profile.language') }} <span class="ml-auto text-danger">{{ errors.first('language') }}</span></label>
                        <select v-model="profile.language" class="form-control" name="language">
                            <option v-for="language in availableLanguages" :value="language" :selected="profile.language === language">{{ $t(`profile.languages.${language}`) }}</option>
                        </select>
                    </div>
                </div>

                <!-- Email, Phone -->
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="email">{{ $t('register.email') }} <span class="ml-auto text-danger">{{ errors.first('email') }}</span></label>
                        <input :value="user.email" type="email" name="email" class="form-control" id="email" :placeholder="$t('register.email')" disabled>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="phone">
                            {{ $t('register.phone') }}
                            <span class="ml-auto text-danger">{{ errors.first('phone') }}</span>
                        </label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <select class="tel-select" v-model="cellphonePrefix">
                                    <option v-for="country in getCountriesByDialCode()" :value="country.dialCode" :selected="country.dialCode === cellphonePrefix">{{ country.dialCode }}</option>
                                </select>
                            </div>

                            <input type="text" class="form-control" v-model="phone" v-validate="'required|numeric'" name="phone" id="phone" :placeholder="$t('register.phone')" :data-vv-as="$t('register.phone')">
                        </div>
                    </div>
                </div>

                <div class="form-row" v-if="profile.id" >
                    <div class="form-group col-6">
                        <label for="email">{{ $t('bin.address') }} <span class="ml-auto text-danger">{{ errors.first('adres') }}</span></label>
                        <GmapAutocomplete v-model="profile.address.formatted" @place_changed="setPlace" name="adres" class="form-control">
                        </GmapAutocomplete>
                    </div>
                </div>

                <GmapMap v-if="profile.id" ref="gmap" :center="center" :zoom="11" map-type-id="roadmap" :options="options" style="width: 100%; height: 200px;">
                    <gmap-marker :position="marker.position" :icon="marker.icon"></gmap-marker>
                </GmapMap>

                <div class="form-row mt-15">
                    <div class="form-group col-12 mb-0">
                        <button class="btn btn-primary mr-30" @click="submit">{{ $t('bin.save') }}</button>
                        <a href="#" @click="sendPasswordResetLink">{{ $t('bin.resetpassword') }}</a>
                    </div>
                </div>

            </form>
        </template>
    </box>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import Rating from "@/components/elements/rating";
const mapstyle = require("@/assets/mapstyles.json");
import Datepicker from 'vuejs-datepicker';

export default {
    components: { Rating, Datepicker },
    data() {
        return {
            profile: {
                id: "",
                first_name: "",
                last_name: "",
                birthday: "",
                email: "",
                cellphone: "",
                language: ""
            },
            cellphonePrefix: "",
            phone: "",  
            new_image: false,
            loading: true,
            // center: { lat: 50.93069, lng: 5.33248 },
            options: {
                styles: mapstyle,
                scrollwheel: false,
                disableDefaultUI: true,
                zoomControl: false
            },
            marker: {
                position: {
                    lat: '',
                    lng: ''
                },
                icon: this.getMarker("orange")
            },
            availableLanguages: ['nl', 'en', 'fr']
        };
    },
    mounted() {
        this.getAuthUser();
        this.initFields();        
    },
    methods: {
        ...mapActions(["updateUser", "resetPassword", "uploadAttachment", "getAuthUser"]),

        /*  
        | -----------------------
        | Initialize all user fields for the current user
        | -----------------------
        */
        initFields() {
            if (this.user) {
                this.profile.id = this.user.id;
                this.profile.first_name = this.user.first_name;
                this.profile.last_name = this.user.last_name;
                this.profile.birthday = this.user.birthday;
                this.profile.email = this.user.email;
                this.profile.language = this.user.language;

                this.loading = false;
                let phone = this.parseCellphone();
                this.phone = phone.number;
                this.cellphonePrefix = phone.prefix;
                this.profile.cellphone = this.user.cellphone

                this.profile.address = JSON.parse(JSON.stringify(this.user.address))

                this.marker.position.lat = this.user.address.location.lat
                this.marker.position.lng = this.user.address.location.lng
            }
        },

        parseCellphone() {
            let country_codes = this.getCountriesByDialCode();
            let country_code = "";
            let phone_number = "";
            country_codes.forEach(country => {
                if (this.user.cellphone.includes(country.dialCode)) {
                    country_code = country.dialCode;
                    phone_number = this.user.cellphone.slice(
                        country_code.length,
                        this.user.cellphone.length
                    );
                }
            });
            return {
                prefix: country_code,
                number: phone_number
            };
        },

        /*  
        | -----------------------
        | Handle event to save all chges made to the user
        | -----------------------
        */
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {            
                    this.updateUser(this.profile)
                        .then(resp => {
                            this.$toasted.show(this.$t('profile.toast.savesuccess'));
                            // this.$forceUpdate()
                            this.initFields() 
                        })
                        .catch(err => {
                            console.log(err);
                            console.log(err.response);
                        });
                }
            });
        },

        setPlace(place) {
            let address = this.normalizeGmapAddress(place)
            this.profile.address = address
            this.profile.address.location = JSON.parse(JSON.stringify(this.user.address.location))        
            this.profile.address.location.lat = this.marker.position.lat = address.lat
            this.profile.address.location.lng = this.marker.position.lng = address.lng
        },

        /*  
        | -----------------------
        | Handle event when a new profile image was uploaded
        | -----------------------
        */
        onFileChange(event) {
            let self = this;
            if (event.target.files && event.target.files[0]) {
                event.target.files[0].vengoType = "profile_picture";
                var reader = new FileReader();

                reader.onload = function(e) {
                    self.new_image = e.target.result;
                    self.profile.image = self.new_image;
                };
                reader.readAsDataURL(event.target.files[0]);
            }

            this.uploadAttachment({
                content: {
                    object: "user",
                    object_id: this.user.id,
                    attachments: []
                },
                type: "profile_picture",
                attachments: [event.target.files[0]]
            })
                .then(resp => {
                    console.log(resp);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        sendPasswordResetLink() {
            this.resetPassword(this.user.email)
                .then(resp => { 
                    this.$toasted.show(this.$t('profile.toast.passwordsuccess'));
                }) 
                .catch(err => {})
        }
    },
    computed: {
        ...mapGetters(["user"]),
        center() {
            return this.marker.position
        }
    },
        
    watch: {
        /*  
        | -----------------------
        | Watch when the user object has loaded or changed
        | -----------------------
        */
        user: function() {
            this.initFields();
        },
        phone(value) {
            this.profile.cellphone = this.cellphonePrefix + value.replace(/\D/g, '').replace(/^0+/g, '')
        },
        cellphonePrefix(value) {
            this.profile.cellphone = value + this.phone.replace(/\D/g, '').replace(/^0+/g, '')
        },
    }
};
</script>
